import React, { createContext, useState } from "react";
import DecoMethodService from "../services/DecoMethodService";

const initialState = {
  loading: false,
  decoMethods: [],
};

const decoMethodsContext = createContext();

const DecoMethodsContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllDecoMethods = async () => {
    setState({ ...state, loading: true });
    const data = await DecoMethodService.getAllDecoMethods();
    setState({ decoMethods: data, loading: false });
  };

  const value = { state, setState, getAllDecoMethods };
  return (
    <decoMethodsContext.Provider value={value}>
      {children}
    </decoMethodsContext.Provider>
  );
};

const useDecoMethodsContext = () => {
  const context = React.useContext(decoMethodsContext);
  if (context === undefined) {
    throw new Error(
      "decoMethodsContext must be used within a DecoMethodsContextProvider"
    );
  }
  return context;
};

export { DecoMethodsContextProvider, useDecoMethodsContext };
